import http from './public'

export default {
    // 获取轮播列表
    cartItemList: (params) => {
        return http.fetchGet('cartItemList', params)
    },

    // 修改勾选
    cartItemUpdate: (url,params) => {
        return http.fetchPost(url, params)
    },
    // 获取轮播列表 测试
    cartItemList2: (params) => {
        return http.fetchGet('cartItemList2', params)
    },



}